import Model from '@models/base/base.model';
import { TraceKeyModel } from '@models/traceKey/traceKey.model';
import type BaseStore from '@stores/base/base.store';
import type { TraceKey } from '@stratumn/studio-shared';
import { makeObservable, observable } from 'mobx';

export abstract class BaseModelWithTraceKey extends Model {
  public traceKey: TraceKeyModel;

  constructor(
    store: BaseStore<Model>,
    id: string,
    traceKeyDTO: TraceKey,
    isLoading?: boolean
  ) {
    super(store, id, isLoading);
    this.traceKey = new TraceKeyModel(store, id, traceKeyDTO);

    makeObservable(this, {
      traceKey: observable
    });
  }

  abstract get toJSON();
}
